<template>
<div class="row">
  <div class="col-lg-12">
    <h3>Login</h3>
    <form>
      <div class="form-group row">
        <label for="password" class="col-sm-2 col-form-label">Password</label>
        <div class="col-sm-10">
          <input @keyup.enter="login" id="password" v-model="password" type="password" class="form-control">
        </div>
      </div>
      <div v-if="authenticated === false" class="alert alert-danger" role="alert">
        <strong>Oh snap!</strong> Username and/or password incorrect
      </div>
      <div class="qm-survey-button-row">
        <button @click="login" type="button" class="btn btn-info qm-survey-edit-button"><i class="fa fa-lock"></i> Login</button>
      </div>
    </form>
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Login',
  data: () => ({
    password: '',
    authenticated: null
  }),
  methods: {
    login () {
      axios.get('/auth', {
        params: {
          password: this.password
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/children/Login.vue